import React from 'react'
import Select from './Select'

const Freestyle = () => {
  return (
    <div className='p-2'>
      <Select/>
    </div>
  )
}

export default Freestyle